/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cashflow_Bank_DiffInputs */

const vi_cashflow_bank_diff = /** @type {(inputs: Cashflow_Bank_DiffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chênh lệch (chưa gán)`)
};

/**

* @param {Cashflow_Bank_DiffInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const cashflow_bank_diff = /** @type {((inputs?: Cashflow_Bank_DiffInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cashflow_Bank_DiffInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cashflow_bank_diff(inputs)
});